import { render, staticRenderFns } from "./SrModalPageBasic.vue?vue&type=template&id=74569084"
import script from "./SrModalPageBasic.vue?vue&type=script&lang=js"
export * from "./SrModalPageBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports